import React, { useState } from 'react';
import { supabase } from '../integrations/supabase/client';

const XmlFeedPage: React.FC = () => {
  const [xmlContent, setXmlContent] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const fetchXMLFeed = async () => {
    setLoading(true);
    try {
      // Buscar o XML da edge function com headers corretos
      const { data, error } = await supabase.functions.invoke('xml-feed', {
        headers: {
          'Accept': 'application/xml'
        }
      });
      
      if (error) throw error;
      
      setXmlContent(data);
    } catch (error) {
      console.error('Erro ao buscar XML:', error);
      alert('Erro ao buscar XML feed');
    } finally {
      setLoading(false);
    }
  };

  const downloadXML = () => {
    if (!xmlContent) {
      alert('Primeiro carregue o XML clicando em "Carregar XML"');
      return;
    }

    const blob = new Blob([xmlContent], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `fox-vendas-feed-${new Date().toISOString().split('T')[0]}.xml`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const copyXMLUrl = () => {
    const xmlUrl = `${window.location.origin}/functions/v1/xml-feed`;
    navigator.clipboard.writeText(xmlUrl);
    alert('URL copiada para a área de transferência!');
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-4">XML Feed - Grupo OLX</h1>
        
        <div className="flex gap-4 mb-6">
          <button
            onClick={fetchXMLFeed}
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Carregando...' : 'Carregar XML'}
          </button>
          
          <button
            onClick={downloadXML}
            disabled={!xmlContent}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
          >
            📥 Baixar XML
          </button>
          
          <button
            onClick={copyXMLUrl}
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
          >
            📋 Copiar URL do Feed
          </button>
        </div>

        <div className="bg-gray-100 p-4 rounded mb-4">
          <h3 className="font-semibold mb-2">URL do Feed para OLX:</h3>
          <code className="bg-white p-2 rounded block">
            {window.location.origin}/functions/v1/xml-feed
          </code>
        </div>
      </div>

      {xmlContent && (
        <div className="border rounded">
          <div className="bg-gray-50 p-3 border-b">
            <h3 className="font-semibold">Conteúdo XML:</h3>
          </div>
          <pre className="p-4 overflow-auto max-h-96 text-sm bg-white">
            {xmlContent}
          </pre>
        </div>
      )}

      {!xmlContent && !loading && (
        <div className="text-center py-12 text-gray-500">
          Clique em "Carregar XML" para visualizar o feed
        </div>
      )}
    </div>
  );
};

export default XmlFeedPage;